import { render, staticRenderFns } from "./ScormView.vue?vue&type=template&id=a319aba4&scoped=true&"
import script from "./ScormView.vue?vue&type=script&lang=js&"
export * from "./ScormView.vue?vue&type=script&lang=js&"
import style0 from "./ScormView.vue?vue&type=style&index=0&id=a319aba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a319aba4",
  null
  
)

export default component.exports